import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './JourneyToolbar.module.css';

const VIEWS = [
	{ key: 'year', label: 'Year' },
	{ key: 'month', label: 'Month' },
	{ key: 'week', label: 'Week' },
	{ key: 'day', label: 'Day' },
	{ key: 'report', label: 'Report' },
];

// `< > TODAY | YEAR MONTH WEEK DAY REPORT`. The report has no anchor date to
// step through — its window always ends today — so the arrows are hidden there.
const JourneyToolbar = ({ view, onViewChange, onPrev, onNext, onToday }) => {
	const showStepper = view !== 'report';

	return (
		<div className={styles.toolbar}>
			{showStepper && (
				<div className={styles.stepper}>
					<button
						type='button'
						className={styles.iconButton}
						onClick={onPrev}
						aria-label={`Previous ${view}`}
					>
						<ChevronLeft size={20} />
					</button>
					<button
						type='button'
						className={styles.iconButton}
						onClick={onNext}
						aria-label={`Next ${view}`}
					>
						<ChevronRight size={20} />
					</button>
					<button type='button' className={styles.todayButton} onClick={onToday}>
						Today
					</button>
				</div>
			)}

			<div className={styles.views} role='tablist' aria-label='Journey view'>
				{VIEWS.map((option) => (
					<button
						key={option.key}
						type='button'
						role='tab'
						aria-selected={view === option.key}
						className={`${styles.viewButton} ${
							view === option.key ? styles.viewButtonActive : ''
						}`}
						onClick={() => onViewChange(option.key)}
					>
						{option.label}
					</button>
				))}
			</div>
		</div>
	);
};

export default JourneyToolbar;
